(function () {
    'use strict';

    angular.module("imApp").factory("docPackTypeChapterService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3279,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3280,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3281,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
